





















































import Vue from "vue";
import { VueTableRequest, ServiceProductOrderApi } from "@/api";
import stateMixin from "@/mixins/state";

export default Vue.extend({
  data() {
    return {
      data: {},
      headers: [
        { text: "#", value: "serviceProductOrderId" },
        { text: "Besteld door", value: "requesterName" },
        { text: "Status", value: "status" }
      ],
      options: {
        sortBy: ["serviceProductOrderId"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 30
      }
    };
  },
  name: "ServiceProductOrderList",
  mixins: [stateMixin],
  mounted() {
    this.fetch();
  },
  methods: {
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new ServiceProductOrderApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: ""
        };
        const {
          data
        } = await api.serviceProductOrderGetServiceProductOrderTable(request);
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  }
});
